export default __webpack_public_path__ + "static/media/Marathi_cf_1.dfb10dc3.mp3";